// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\"><path fill=\"none\" stroke=\"#364F6B\" stroke-width=\"2\" d=\"m20 15-4 4-4-4\"/></svg>";
// Exports
module.exports = code;